import { hot } from 'react-hot-loader/root';
import Component from './generalSettings-redux';

export default hot(Component);
